import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { TransportProvider } from "@empite/session";
/**
 * AppProviders is the two contexts every portal needs, in the order they
 * depend on each other: the session hooks call the transport from inside a
 * query, so the transport provider has to be the inner one.
 */
export function AppProviders({ queryClient, transport, children }) {
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(TransportProvider, { transport: transport, children: children }) }));
}
//# sourceMappingURL=providers.js.map